import { all, takeLeading } from 'redux-saga/effects';

import { connectCall, createBroadcastForm, createCall, planBroadcast, planCall } from '../slice';
import {
    connectCallSaga,
    createBroadcastFormSaga,
    createCallSaga,
    planBroadcastSaga,
    planCallSaga,
} from './create-call';

/**
 *
 */
export default function* (): Generator {
    yield all([
        takeLeading(createCall.type, createCallSaga),
        takeLeading(connectCall.type, connectCallSaga),
        takeLeading(planCall.type, planCallSaga),
        takeLeading(planBroadcast.type, planBroadcastSaga),
        takeLeading(createBroadcastForm.type, createBroadcastFormSaga),
    ]);
}
